import React from "react";
import { Materials2050EPDDetailOUT } from "api-client";
import { useTranslation } from "react-i18next";
import { roundNumber } from "utils";
import { REFERENCE_UNITS } from "features/MappingTools/consts";
import { globalStore } from "store/GlobalStore";

const ReferenceValues = ({
  details,
}: {
  details: Materials2050EPDDetailOUT | null;
}) => {
  const { t } = useTranslation();
  const currentRefUnit = REFERENCE_UNITS.find(
    (item) => item.id.toLowerCase() === details?.reference_unit?.toLowerCase()
  );

  const data = [
    {
      title: t("productEditor.referenceUnit"),
      value:
        globalStore.currentLanguage === "de"
          ? currentRefUnit?.name_de
          : currentRefUnit?.name,
    },
    {
      title: t("productEditor.referenceFactor"),
      value: details?.reference_factor,
    },
    {
      title: t("productEditor.lengthWidth"),
      value: details?.mass_value_m,
      unit: "kg/m",
    },
    {
      title: t("productEditor.surfaceWeight"),
      value: details?.mass_value_m2,
      unit: "kg/m²",
    },
    {
      title: t("productEditor.rawDensity"),
      value: details?.mass_value_m3,
      unit: "kg/m³",
    },
  ];

  return (
    <div className="mb-4 mt-4">
      <div className="font-semibold text-base mb-3">
        {t("productEditor.referenceValues")}
      </div>
      <div className="flex items-center flex-wrap border-b border-gray-200 pb-2">
        {data.map((item, index) => (
          <div key={index} className="mr-4 mb-2">
            <div className="text-gray-800 text-sm font-medium flex">
              {item.title}
            </div>
            <div className="text-gray-500 text-sm">
              {`${
                (typeof item.value === "number"
                  ? roundNumber(Number(item.value))
                  : item.value) || "-"
              } ${item.value ? item.unit ?? "" : ""}`}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferenceValues;
